import { Component, Input } from '@angular/core';
import { CardComponent } from '@app/components/platform';
import { SegmentHeaderComponent } from '@app/components/segment-header/segment-header.component';
import { T4Summary } from '@app/models/payroll/t4-summary.model';
import { TaxReturnSummaryDetailsRowComponent } from './tax-return-summary-details-row.component';

@Component({
    selector: 'app-t4-summary-details',
    templateUrl: './t4-summary-details.template.html',
    styles: [
        `
            :host {
                --card-bottom-margin: 0;
            }
        `,
    ],
    standalone: true,
    imports: [CardComponent, SegmentHeaderComponent, TaxReturnSummaryDetailsRowComponent],
})
export class T4SummaryDetailsComponent {
    @Input({ required: true }) t4Summary!: T4Summary;
}
